// @core/api/endpoints/resource/search_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchResourcesResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Search resources
 * Performs a full-text search across all resources in the tenant. Supports filtering by resource type, product, and date range.
 */
export async function SearchResources(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    q?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<SearchResourcesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/search`;
  const requestOptions = options;
  return client.get<SearchResourcesResponse>(requestPath, { ...requestOptions, params });
}
